export const CHANGE_USER_PASSWORD_REQUEST = 'CHANGE_USER_PASSWORD_REQUEST';
export const CHANGE_USER_PASSWORD_SUCCESS = 'CHANGE_USER_PASSWORD_SUCCESS';
export const CHANGE_USER_PASSWORD_FAILURE = 'CHANGE_USER_PASSWORD_FAILURE';

export const CHANGE_USER_STATUS_REQUEST = 'CHANGE_USER_STATUS_REQUEST';
export const CHANGE_USER_STATUS_SUCCESS = 'CHANGE_USER_STATUS_SUCCESS';
export const CHANGE_USER_STATUS_FAILURE = 'CHANGE_USER_STATUS_FAILURE';


export const FETCH_USER_DATA_REQUEST = 'FETCH_USER_DATA_REQUEST';
export const FETCH_USER_DATA_SUCCESS = 'FETCH_USER_DATA_SUCCESS';
export const FETCH_USER_DATA_FAILURE = 'FETCH_USER_DATA_FAILURE';

export const CREATE_USER_REQUEST = 'CREATE_USER_REQUEST';
export const CREATE_USER_SUCCESS = 'CREATE_USER_SUCCESS';
export const CREATE_USER_FAILURE = 'CREATE_USER_FAILURE';

export const UPDATE_USER_REQUEST = 'UPDATE_USER_REQUEST';
export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS';
export const UPDATE_USER_FAILURE = 'UPDATE_USER_FAILURE';

// Action Types
export const FETCH_TEAMS_REQUEST = 'FETCH_TEAMS_REQUEST';
export const FETCH_TEAMS_SUCCESS = 'FETCH_TEAMS_SUCCESS';
export const FETCH_TEAMS_FAILURE = 'FETCH_TEAMS_FAILURE';

// Action Creators for Fetching Teams
export const fetchTeamsRequest = (page = 1, limit = 1, search = '') => ({
  type: FETCH_TEAMS_REQUEST,
  payload: { page, limit, search },
});

export const fetchTeamsSuccess = (data) => ({
  type: FETCH_TEAMS_SUCCESS,
  payload: data,
});

export const fetchTeamsFailure = (error) => ({
  type: FETCH_TEAMS_FAILURE,
  payload: error,
});



export const fetchUserDataRequest = ({ page = 1, limit = 1, search = '' } = {}) => ({
    type: FETCH_USER_DATA_REQUEST,
    payload:{page,limit,search}
  });
  
  export const fetchUserDataSuccess = (data) => ({
    type: FETCH_USER_DATA_SUCCESS,
    payload: data,
  });
  
  export const fetchUserDataFailure = (error) => ({
    type: FETCH_USER_DATA_FAILURE,
    payload: error,
  });
  
  // Action creators for creating a user
  export const createUserRequest = (userData) => ({
    type: CREATE_USER_REQUEST,
    payload: userData,
  });
  
  export const createUserSuccess = (data) => ({
    type: CREATE_USER_SUCCESS,
    payload: data,
  });
  
  export const createUserFailure = (error) => ({
    type: CREATE_USER_FAILURE,
    payload: error,
  });

  export const updateUserRequest = (userData) => ({
    type: UPDATE_USER_REQUEST,
    payload: userData,
  });
  
  export const updateUserSuccess = (data) => ({
    type: UPDATE_USER_SUCCESS,
    payload: data,
  });
  
  export const updateUserFailure = (error) => ({
    type: UPDATE_USER_FAILURE,
    payload: error,
  });



export const changeUserPasswordRequest = (userData) => ({ type: CHANGE_USER_PASSWORD_REQUEST, payload: userData });
export const changeUserPasswordSuccess = (data) => ({ type: CHANGE_USER_PASSWORD_SUCCESS, payload: data });
export const changeUserPasswordFailure = (error) => ({ type: CHANGE_USER_PASSWORD_FAILURE, payload: error });

export const changeUserStatusRequest = (data) => ({
  type: CHANGE_USER_STATUS_REQUEST,
  payload : data,
});
export const changeUserStatusSuccess = (data) => ({ type: CHANGE_USER_STATUS_SUCCESS, payload: data });
export const changeUserStatusFailure = (error) => ({ type: CHANGE_USER_STATUS_FAILURE, payload: error });
